import { Textarea } from '@mantine/core'

// Textarea renders InputBase internally and uses static class names.
// Focus styles are applied globally via focusRing.css targeting .mantine-Textarea-input
export const TextareaThemeKobo = Textarea.extend({})
